import { render } from "./formularioEdicionManualTarjeta.vue?vue&type=template&id=46258832"
import script from "./formularioEdicionManualTarjeta.vue?vue&type=script&lang=js"
export * from "./formularioEdicionManualTarjeta.vue?vue&type=script&lang=js"

import "./formularioEdicionManualTarjeta.vue?vue&type=style&index=0&id=46258832&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__